import React, { ComponentProps } from 'react'

import StarRating from 'components/Common/StarRating'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'
import { useIsMobileScreen } from 'lib/web/deviceUtils'

type Size = 'S' | 'M'
const BODY_TEXT_SIZES: Record<
  Size,
  ComponentProps<typeof BodyText>['variant']
> = {
  S: 'small',
  M: 'medium',
}

const STAR_RATING_SIZES: Record<
  Size,
  ComponentProps<typeof StarRating>['size']
> = {
  S: 12,
  M: 'XS',
}

type Props = {
  rating: number
  ratingsCount?: number
  size: Size
  className?: string
  label?: string
}
const numberFormatter = new Intl.NumberFormat('en')

function GooglePlaceRatingDisplay(props: Props) {
  const { rating, ratingsCount, label, className, size } = props

  const isMobileScreen = useIsMobileScreen()

  const formattedCount = ratingsCount
    ? numberFormatter.format(ratingsCount)
    : undefined

  return (
    <Group gap={8} direction="vertical" className={className}>
      {label && (
        <BodyText variant="medium" weight="semi-bold">
          {label}
        </BodyText>
      )}
      <Group
        gap={8}
        direction="horizontal"
        horizontalAlign="start"
        verticalAlign="center"
      >
        <BodyText variant={BODY_TEXT_SIZES[size]}>{rating}</BodyText>
        <StarRating max={5} value={rating} size={STAR_RATING_SIZES[size]} />
        {formattedCount && (
          <BodyText variant={BODY_TEXT_SIZES[size]}>
            ({formattedCount}
            {isMobileScreen ? '' : ' Google reviews'})
          </BodyText>
        )}
      </Group>
    </Group>
  )
}

export default GooglePlaceRatingDisplay
